import { Schema } from 'rsuite'

const { StringType } = Schema.Types

export default Schema.Model({
  system_name: StringType().isRequired('Поле обязательно для заполнения')
})
